
import { useEffect, useRef, useState } from "react";
import MeaButton from "../../../../components/MeaButton";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import tasksAPI from "../../../../services/tasks";
import levelsAPI from "../../../../services/levels";
import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ToFormatedDateWithWeekday, ToFormatedHour } from "../../../../utils/dates";
import trainingsAPI from "../../../../services/trainings";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ExportRegistrationsComponent = ({ schoolId, trainingId }) => {

  const accessToken = "";
  const [loading, setLoading] = useState(false);
  const [hasLogs, setHasLogs] = useState(false);
  const [logsTitle, setLogsTitle] = useState(null);
  const [logs, setLogs] = useState([]);

  const [exportedFilename, setExportedFilename] = useState(null);

  const [selectedSourceTraining, setSelectedSourceTraining] = useState(null);
  //
  const trainingQuery = trainingsAPI.useGetList(schoolId, accessToken, 1, 10000);
  const trainings = trainingQuery?.data?.data;
  const filteredTrainings = trainings?.filter(training => training.id !== trainingId);
  //
  const sourceLevelsQuery = levelsAPI.useGetList(schoolId, selectedSourceTraining, accessToken, 1, 100000);
  const sourceLevels = sourceLevelsQuery?.data?.data;
  //
  const targetLevelsQuery = levelsAPI.useGetList(schoolId, trainingId, accessToken, 1, 100000);
  const targetLevels = targetLevelsQuery?.data?.data;
  //
  const levelsMapping = sourceLevels?.map(level => ({
    "sourceLevelId": level.id,
    "sourceLevelName": level.name,
    "targetLevelFailedId": null,
    "targetLevelFailedName": null,
    "targetLevelPassedId": null,
    "targetLevelPassedName": null
  }));
  //
  const resultsRef = useRef(null);

  const [levelMappings, setLevelMappings] = useState([]);
  useEffect(() => {
    setLevelMappings(levelsMapping);
  }, [sourceLevels]);

  const categories = [
    { name: 'Redoubelement', key: 'FAILED' },
    { name: 'Passage', key: 'PASSED' },
    { name: 'Liste d\'attente', key: 'WAITING_LIST' },
  ];

  const [selectedCategories, setSelectedCategories] = useState([]);

  const onCategoryChange = (e) => {
    let _selectedCategories = [...selectedCategories];
    if (e.checked)
      _selectedCategories.push(e.value);
    else
      _selectedCategories = _selectedCategories.filter(category => category.key !== e.value.key);
    setSelectedCategories(_selectedCategories);
  };

  const [jobId, setJobId] = useState(null);

  useEffect(() => {
    if (selectedSourceTraining !== null && selectedSourceTraining !== undefined) {
      trainingsAPI.GetTrainingPreferences(schoolId, trainingId, accessToken).then((data) => {
        const mappings = data?.import_trainings_mappings;
        if (mappings) {
          const decodedMappings = JSON.parse(atob(mappings));
          const levelMappings = decodedMappings.find(mapping => mapping.source_training_id === selectedSourceTraining)?.mappings;
          setLevelMappings(levelMappings);
        };
      });
    }
  }, [selectedSourceTraining]);


  const handleExport = () => {
    setLoading(true);
    setLogsTitle("Exportation des élèves...");
    setLogs([]);
    tasksAPI.ExportStudentsToExcelFile(schoolId, trainingId, accessToken,
      {
        level_id: null,
        class_id: null,
        result: null,
      })
      .then((json) => {
        setJobId(json?.data?.id);
        setHasLogs(true);
      }).catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    const fetchTaskStatus = async () => {
      tasksAPI.GetTask(schoolId, trainingId, jobId, accessToken)
        .then((data) => {
          setLogsTitle(data?.data?.message);
          setLogs(data?.data?.job_logs);
          if (data?.data?.status === "COMPLETED") {
            {
              setExportedFilename(data?.data?.media_file);
              setLoading(false);
              setJobId(null);
            }
          } else if (data?.data?.status === "FAILED") {
            {
              //setSuccessMessage();
              //setErrorMessage(data?.data?.message);
              setLoading(false);
              setJobId(null);
            }
          }
          else {
            setTimeout(fetchTaskStatus, 1000); // Retry after 1 seconds
          }
        })
        .catch((error) => {
          console.log("error " + error);
          //setSuccessMessage(null);
          //setErrorMessage("Erreur de chargement du fichier!");
          setJobId(null);
          setLoading(false);
        });
    };

    if (loading && jobId) {
      fetchTaskStatus();
    }

  }, [loading, jobId]);

  return (
    <>
      <ConfirmDialog />
      <div className="flex flex-column mt-3 p-5 bg-white">
        {/* 
                    <div className="mb-4">Rafiner les filtres suivants pour choisir les élèves à exporter.</div>
                    */}
        <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
          <ul className="list-none p-0 m-0">
            {/* 
                            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
                                <div className="text-500 w-full md:w-3 font-medium">Niveau</div>
                                <div className="text-900 w-full md:w-9">
                                    <Dropdown disabled={hasLogs} value={filteredTrainings?.find(training => training?.id === selectedSourceTraining)}
                                        options={filteredTrainings} optionLabel="name" placeholder="Sélectionner une formation"
                                        onChange={(e) => setSelectedSourceTraining(e.value?.id)} />
                                </div>
                            </li>
                            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
                                <div className="text-500 w-full md:w-3 font-medium">Classe</div>
                                <div className="text-900 w-full md:w-9">
                                    <Dropdown disabled={hasLogs} value={filteredTrainings?.find(training => training?.id === selectedSourceTraining)}
                                        options={filteredTrainings} optionLabel="name" placeholder="Sélectionner une formation"
                                        onChange={(e) => setSelectedSourceTraining(e.value?.id)} />
                                </div>
                            </li>
                            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
                                <div className="text-500 w-full md:w-3 font-medium">Avis de passage</div>
                                <div className="text-900 w-full md:w-9">
                                    <Dropdown disabled={hasLogs} value={filteredTrainings?.find(training => training?.id === selectedSourceTraining)}
                                        options={filteredTrainings} optionLabel="name" placeholder="Sélectionner une formation"
                                        onChange={(e) => setSelectedSourceTraining(e.value?.id)} />
                                </div>
                            </li>
                            */}
            <li>
              <MeaButton label="Exporter" loading={loading} className="mt-5" onClick={(e) => {
                e.stopPropagation();

                confirmDialog({
                  message:
                    "Voulez-vous procéder à l'exportation des élèves avec les filtres séléctionnés ?",
                  header: "Confirmation",
                  icon: "pi pi-info-circle",
                  acceptLabel: "Oui",
                  rejectLabel: "Non",
                  defaultFocus: "reject",
                  reject: () => {
                    setLoading(false);
                  },
                  accept: () => {
                    handleExport();
                  },
                });
              }}
              />
              {hasLogs && !loading && <MeaButton label="Fermer" outlined className="mt-5 ml-3" onClick={() => window.history.back()} />}
              {exportedFilename && <MeaButton label="Télécharger le fichier" severity="success" className="mt-5 ml-3"
                onClick={() => window.open(`${BACKEND_URL}/api/v1/schools/${schoolId}/trainings/${trainingId}/medias/${exportedFilename}?download=true`, '_blank')} />}
            </li>
            {hasLogs && <li className="mt-3">
              <Panel ref={resultsRef} header={logsTitle} toggleable collapsed>
                <DataTable value={logs} size="small">
                  <Column field="log_type" header="Type" body={(item) =>
                    <span className={item?.log_type === "WARNING" ? "text-orange-500" : (item?.log_type === "ERRR" ? "text-red-500" : "")}>{item?.log_type}</span>
                  }></Column>
                  <Column field="message" header="Message" ></Column>
                  <Column field="created_at" header="Emis le" body={(item) => <>
                    {ToFormatedDateWithWeekday(new Date(item?.created_at)) + "  " + ToFormatedHour(new Date(item?.created_at))}
                  </>}></Column>
                </DataTable>

              </Panel>
            </li>}
          </ul>
        </div>

      </div>

    </>
  );
}
export default ExportRegistrationsComponent;
